"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValueDifference_1 = require("../../core/model/ValueDifference");

var ForecastChangeSupplierAgreementDTO_1 = require("../model/ForecastChangeSupplierAgreementDTO");

var ForecastChangeSupplierAgreementDTOConverter_1 = require("./ForecastChangeSupplierAgreementDTOConverter");
/**
 * @author Adam Drda
 */


var ForecastChangeSupplierAgreementDTOConverterImpl =
/*#__PURE__*/
function (_ForecastChangeSuppli) {
  _inherits(ForecastChangeSupplierAgreementDTOConverterImpl, _ForecastChangeSuppli);

  function ForecastChangeSupplierAgreementDTOConverterImpl() {
    _classCallCheck(this, ForecastChangeSupplierAgreementDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ForecastChangeSupplierAgreementDTOConverterImpl).apply(this, arguments));
  }

  _createClass(ForecastChangeSupplierAgreementDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ForecastChangeSupplierAgreementDTO_1.ForecastChangeSupplierAgreementDTO(ForecastChangeSupplierAgreementDTO_1.ForecastChangeSupplierAgreementDTO.schema.supplierId.valueOf(conversions.toClassReferenceId(source.supplierId)), ForecastChangeSupplierAgreementDTO_1.ForecastChangeSupplierAgreementDTO.schema.preferred.valueOfField(source), conversions.asObject(source, 'promoPurchasePrice', ValueDifference_1.deserializeValueDifferenceBigNumber(conversions)), conversions.asObject(source, 'unitBackDiscount', ValueDifference_1.deserializeValueDifferenceBigNumber(conversions)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return {
        supplierId: conversions.toDocumentReferenceId(source.supplierId),
        preferred: source.preferred,
        promoPurchasePrice: conversions.asObject(source, 'promoPurchasePrice', ValueDifference_1.serializeValueDifferenceBigNumber(conversions)),
        unitBackDiscount: conversions.asObject(source, 'unitBackDiscount', ValueDifference_1.serializeValueDifferenceBigNumber(conversions))
      };
    }
  }]);

  return ForecastChangeSupplierAgreementDTOConverterImpl;
}(ForecastChangeSupplierAgreementDTOConverter_1.ForecastChangeSupplierAgreementDTOConverter);

exports.ForecastChangeSupplierAgreementDTOConverterImpl = ForecastChangeSupplierAgreementDTOConverterImpl;